import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api/instance';

export interface AdvPromoTranslation {
  lang: string;
  promoTitle?: string;
  promoDescription?: string;
  modalTitle?: string;
  modalDescription?: string;
}

export interface AdvPromoData {
  promo_visible: boolean;
  promo_preview_url: string;
  modal_preview_url?: string | null;
  show_at_session_start: boolean;
  translations: {
    [lang: string]: Omit<AdvPromoTranslation, 'lang'>;
  };
}

export interface AdvPromoTypes {
  id: string;
  companyId: string;
  promoVisible: boolean;
  promoPreviewUrl: string;
  modalPreviewUrl: string | null;
  showAtSessionStart: boolean;
  translations: AdvPromoTranslation[];
}

const companyAdvPromoPath = (companyId: string) => `/companies/${companyId}/advertisements/promo`;

export const getPromo = async ({ companyId }: { companyId: string }): Promise<AxiosResponse<AdvPromoTypes>> => {
  return instance.get(companyAdvPromoPath(companyId)).catch(e => e.response as AxiosError<ApiError> as never);
};

export const createPromo = async ({ companyId, data }: { companyId: string; data: AdvPromoData }) => {
  return instance
    .post<AdvPromoTypes>(companyAdvPromoPath(companyId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const updatePromo = async ({ companyId, data }: { companyId: string; data: AdvPromoData }) => {
  return instance
    .put<AdvPromoTypes>(companyAdvPromoPath(companyId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deletePromo = async ({ companyId }: { companyId: string }) => {
  return instance.delete(companyAdvPromoPath(companyId)).catch(e => e.response as AxiosError<ApiError> as never);
};

export const uploadPromoImage = async ({
  companyId,
  filename,
  assetType,
}: {
  companyId: string;
  filename: string;
  assetType: 'promo' | 'modal';
}) => {
  const response = await instance.post(`/companies/${companyId}/advertisements/upload-image`, {
    filename,
    asset_type: assetType,
  });
  return response.data;
};
